module.exports = __webpack_public_path__ + "static/media/loginvideo.eb39d2cc.mp4";